// Note: These 2 polyfills MUST remain at the top of this file.
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter, Switch} from 'react-router-dom';
import {gel3Themes, GlobalStyle} from '@snsw-gel/react';
import {
    ApplicationContextProvider,
    ApplicationConfigContext,
} from '@gaas/gaas-react-component-library';
import {Auth, BaseRoute} from './external-components';
import {GlobalNavWrapper} from './external-components/GlobalNavWrapper/GlobalNavWrapper';
import * as serviceWorker from './serviceWorker';
import routes from './routes';

import config from './config/config';
import {initialiseConfig} from './config/initialiseConfig';
import {TollRegistrationProvider} from './context/ApplicationContext';
import {CookiesProvider} from 'react-cookie';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';

const routeEntries = Object.entries(routes);

const actualRoutes = routeEntries.filter(([key, value]) => Object.keys(value).includes('path'));

console.log(`Starting React App: ${config.appTitle} - ${config.appRevision}`);
initialiseConfig();

ReactDOM.render(
    <React.StrictMode>
        <ApplicationContextProvider>
            <ApplicationConfigContext.Provider value={config}>
                <QueryClientProvider client={new QueryClient()}>
                    <TollRegistrationProvider>
                        <CookiesProvider>
                            <GlobalStyle themes={gel3Themes}/>
                            <GlobalNavWrapper>
                                <main id='main-content'>
                                    <BrowserRouter basename={process.env.PUBLIC_URL}>
                                        <Auth>
                                            <Switch>
                                                {actualRoutes.map(
                                                    ([
                                                         key,
                                                         {
                                                             title,
                                                             exact,
                                                             path,
                                                             component: Component,
                                                             route,
                                                             sessionTimeoutEnabled,
                                                             usePoi,
                                                             ...rest
                                                         },
                                                     ]) => {
                                                        const Route = route ?? BaseRoute;

                                                        return (
                                                            <Route
                                                                appName={config.appTitle}
                                                                pageTitle={title}
                                                                exact={exact}
                                                                key={key}
                                                                path={path}
                                                                component={(props: any) => {
                                                                    return <Component {...props} {...rest} />;
                                                                }}
                                                                sessionTimeoutEnabled={sessionTimeoutEnabled}
                                                                usePoi={usePoi}
                                                            />
                                                        );
                                                    },
                                                )}
                                            </Switch>
                                        </Auth>
                                    </BrowserRouter>
                                </main>
                            </GlobalNavWrapper>
                        </CookiesProvider>
                    </TollRegistrationProvider>
                </QueryClientProvider>
            </ApplicationConfigContext.Provider>
        </ApplicationContextProvider>
    </React.StrictMode>,
    document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
